// Mirrors the backend's freeform SMS rule (support_and_communications
// services/communications.py _sms_length_and_limit) so the counter agrees
// with what the server will accept: a single segment is 160 GSM-7
// characters, the GSM-7 extended characters cost two each, and any
// character outside the GSM-7 alphabet (emoji, curly quotes, most accented
// letters) switches the whole message to UCS-2, where a segment holds 70.
export const SMS_GSM7_LIMIT = 160;
export const SMS_UCS2_LIMIT = 70;

const GSM7_BASIC = new Set(
  '@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !"#¤%&\'()*+,-./0123456789:;<=>?' +
    '¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà'
);
const GSM7_EXTENDED = new Set('^{}\\[~]|€\f');

export interface SmsLength {
  length: number;
  limit: number;
  unicode: boolean;
}

export function smsLength(message: string): SmsLength {
  const chars = Array.from(message || '');
  const isGsm7 = chars.every((c) => GSM7_BASIC.has(c) || GSM7_EXTENDED.has(c));
  if (isGsm7) {
    return {
      length: chars.reduce((total, c) => total + (GSM7_EXTENDED.has(c) ? 2 : 1), 0),
      limit: SMS_GSM7_LIMIT,
      unicode: false
    };
  }
  // The backend counts Python str length (code points) here too.
  return { length: chars.length, limit: SMS_UCS2_LIMIT, unicode: true };
}
